import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=11424216&lang=pug&"
import script from "./ProductActions.vue?vue&type=script&lang=js&"
export * from "./ProductActions.vue?vue&type=script&lang=js&"
import style0 from "./ProductActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports